// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%236b7280%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   Settings — 설정 영역
   사이드바 + 우측 컨텐츠 (760px 고정폭) 레이아웃
   ======================================================================== */

/* ───────── 사이드바 (Figma Frame 81 — 라이트 #f2f2f2) ───────── */
/* 컨테이너 배경/너비/패딩은 .prompt__sidebar 기본을 그대로 사용 */
.settings__sidebar {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.settings__sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 0;
}

/* 메뉴 항목 — 폭 100% / padding 10px / gap 4px / radius 12px */
.settings__sidebar-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px;
  background: transparent;
  border: 0;
  border-radius: 12px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  line-height: 1;
  color: var(--fg-text-basic, #3b3b3b);
  cursor: pointer;
  text-align: left;
  transition: var(--transition-fast, all 0.15s ease);
}

.settings__sidebar-item:hover {
  background: rgba(0, 0, 0, 0.04);
}

.settings__sidebar-item--active {
  background: #fff;
  color: var(--fg-text-basic, #3b3b3b);
  font-weight: 500;
  box-shadow: none;
}

.settings__sidebar-item--active:hover {
  background: #fff;
}

.settings__sidebar-item--logout {
  margin-top: 8px;
}

.settings__sidebar-item--logout:hover {
  background: rgba(0, 0, 0, 0.04);
  color: var(--danger-500, #ef4444);
}

.settings__sidebar-item-icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  color: inherit;
}

.settings__sidebar-item-label {
  flex: 1 1;
}

/* ───────── 컨텐츠 영역 ───────── */
.settings__main {
  display: flex;
  justify-content: center;
}

.settings__content {
  width: 100%;
  padding: 30px 0 80px;
  margin: 0 auto;
}

.settings__heading {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 24px;
}

.settings__title {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings__heading-help {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  color: var(--fg-text-gray, #838383);
  cursor: pointer;
}

.settings__description {
  margin: -12px 0 24px;
  font-size: 14px;
  line-height: 1.6;
  color: var(--fg-text-gray, #838383);
}

/* ───────── 섹션 ───────── */
.settings-section {
  margin-bottom: 32px;
}

.settings-section__title {
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 600;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-section__sub {
  margin: -8px 0 16px;
  font-size: 14px;
  line-height: 1.6;
  color: var(--fg-text-gray, #838383);
}

.settings-section__group {
  background: #fff;
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 12px;
  overflow: hidden;
}

.settings-section__group > * + * {
  border-top: 1px solid var(--fg-line, #dbdbdb);
}

/* ───────── 폼 행 ───────── */
.settings-form {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;
  background: #fff;
}

.settings-form--readonly {
  background: var(--fg-box-bg, #fbfbfb);
}

.settings-form__label-wrap {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  padding-top: 12px;
  flex-shrink: 0;
  width: 180px;
}

.settings-form__label {
  font-size: 16px;
  font-weight: 600;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-form__required {
  display: inline-flex;
  align-items: center;
  margin-top: 4px;
  color: #e74c3c;
}

.settings-form__control-wrap {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 540px;
}

.settings-form__input {
  width: 100%;
  padding: 8px 12px;
  background: #f8f8f8;
  border: 0;
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic, #3b3b3b);
  outline: none;
}

.settings-form__input::placeholder {
  color: var(--fg-text-gray, #838383);
}

.settings-form__input:focus {
  background: #fff;
  box-shadow: inset 0 0 0 1px var(--fg-button-hover, #7362c2);
}

.settings-form__input--readonly {
  background: var(--fg-box-bg, #fbfbfb);
  border: 1px solid var(--fg-line, #dbdbdb);
  color: var(--fg-text-gray, #838383);
  display: flex;
  align-items: center;
}

.settings-form__input--select {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  text-align: left;
}

.settings-form__placeholder {
  color: var(--fg-text-gray, #838383);
}

.settings-form__textarea {
  width: 100%;
  min-height: 113px;
  padding: 8px 12px;
  background: #f8f8f8;
  border: 0;
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic, #3b3b3b);
  outline: none;
  resize: vertical;
}

.settings-form__textarea::placeholder {
  color: var(--fg-text-gray, #838383);
}

.settings-form__helper {
  margin: 0;
  font-size: 14px;
  color: var(--fg-text-gray, #838383);
}

/* ───────── 액션 버튼 ───────── */
.settings-action-row {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
}

.settings-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 48px;
  padding: 10px 16px;
  border: 0;
  border-radius: 12px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: var(--transition-fast, all 0.15s ease);
}

.settings-btn--primary {
  background: var(--fg-button-normal, #978cca);
  color: #fff;
}

.settings-btn--primary:hover {
  background: var(--fg-button-hover, #7362c2);
}

.settings-btn--secondary {
  background: var(--fg-text-gray, #838383);
  color: #fff;
}

.settings-btn--secondary:hover {
  background: #555;
}

.settings-btn--ghost {
  background: #fff;
  border: 1px solid var(--fg-line, #dbdbdb);
  color: var(--fg-text-basic, #3b3b3b);
  min-height: 36px;
  padding: 6px 10px;
  font-size: 14px;
  font-weight: 500;
}

.settings-btn--ghost:hover {
  background: var(--fg-bg-liteblue, #f6f8ff);
}

.settings-btn--has-text {
  padding: 6px 12px;
}

.settings-btn--sm {
  min-height: 32px;
  padding: 4px 12px;
  font-size: 14px;
  font-weight: 500;
}

/* ───────── 계정 화면 ───────── */
.settings-account {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.settings-account__profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.settings-account__avatar-wrap {
  position: relative;
  width: 160px;
  height: 160px;
}

.settings-account__avatar {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: linear-gradient(135deg, #d8d4ee, #978cca);
}

.settings-account__avatar-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: #fff;
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 50%;
  color: var(--fg-text-basic, #3b3b3b);
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.settings-account__name {
  margin: 0;
  font-size: 36px;
  font-weight: 600;
  line-height: 46px;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-account__email {
  margin: 0;
  font-size: 14px;
  color: var(--link-normal, #2c95f8);
}

.settings-account__badge {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid var(--fg-text-basic, #3b3b3b);
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-account__form-group {
  background: #fff;
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 12px;
  overflow: hidden;
}

.settings-account__form-group > .settings-form + .settings-form {
  border-top: 1px solid var(--fg-line, #dbdbdb);
}

/* ───────── 토큰 화면 (Figma Frame 395) ───────── */
.settings-token-summary {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 32px;
}

/* Frame 228 — 다크 hero (잔여 토큰 진행바 + 충전/요금제 버튼) */
.settings-token-hero {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 20px;
  background: var(--fg-bg-dark, #2f3247);
  border-radius: 12px;
}

.settings-token-hero__bar-wrap {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.settings-token-hero__bar-head {
  display: flex;
  align-items: center;
  gap: 4px;
}

.settings-token-hero__bar-label {
  flex: 1 1;
  font-size: 14px;
  font-weight: 700;
  color: var(--fg-text-menu, #bdbdbd);
}

.settings-token-hero__bar-value {
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-anti-red, #ff1500);
  white-space: nowrap;
  text-align: right;
}

/* 진행바 — fill을 우측 정렬 */
.settings-token-hero__bar {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 5px;
  background: var(--fg-text-menu, #bdbdbd);
  border-radius: 10px;
  overflow: hidden;
}

.settings-token-hero__bar-fill {
  height: 100%;
  background: var(--fg-anti-red, #ff1500);
  border-radius: 10px;
}

/* 우측 toolbar 버튼 (충전 / 요금제 업그레이드) */
.settings-token-hero__btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 5px 7px 7px;
  background: var(--fg-button, #978cca);
  border: 0;
  border-radius: 4px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  transition: var(--transition-fast, all 0.15s ease);
}

.settings-token-hero__btn:hover {
  background: var(--fg-button-hover, #7362c2);
}

.settings-token-hero__btn > svg {
  flex-shrink: 0;
}

/* 3개 카드 — 각자 분리된 박스 (gap 8px) */
.settings-token-cards {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.settings-token-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #fff;
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 12px;
}

/* 잔여 토큰(첫 번째) 강조 카드 — 옅은 푸른 배경 + 보라 네이비 보더 */
.settings-token-card--highlight {
  background: #f3fbff;
  border-color: var(--fg-side-hover, #4c5ed9);
}

.settings-token-card__body {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.settings-token-card__label {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-token-card__sub {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: var(--fg-text-gray, #838383);
}

.settings-token-card__value {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--fg-side-hover, #4c5ed9);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

/* ================================================================
 * 요금제 섹션 (피그마 node 1:7001)
 *   - 헤더 + 결제 주기 토글 + 3-컬럼 플랜 카드 그리드
 * ================================================================ */
.settings-plan-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 40px;
}

.settings-plan-section__head {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 40px;
}

.settings-plan-section__title {
  margin: 0;
  font-family: var(--font-sans);
  font-size: 28px;
  font-weight: 600;
  line-height: 40px;
  color: var(--fg-text-basic, #3b3b3b);
  letter-spacing: 0;
}

.settings-plan-section__help {
  border: 0;
  background: transparent;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md, 6px);
  color: var(--fg-text-gray, #838383);
  cursor: pointer;
  padding: 0;
}

.settings-plan-section__help:hover {
  color: var(--fg-text-basic, #3b3b3b);
  background: var(--fg-bg-content, var(--gray-100));
}

.settings-plan-section__controls {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.settings-plan-toggle {
  display: inline-flex;
  align-items: center;
  gap: 1px;
  border-radius: var(--radius-sm, 4px);
  overflow: hidden;
}

.settings-plan-toggle__btn {
  height: 32px;
  padding: 5px 7px 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: var(--fg-bg-litepp, #e8eaf5);
  color: var(--fg-button-hover, #7362c2);
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: background var(--transition-fast), color var(--transition-fast);
}

.settings-plan-toggle__btn:hover {
  background: #dfe2f0;
}

.settings-plan-toggle__btn--active,
.settings-plan-toggle__btn--active:hover {
  background: var(--fg-button, #978cca);
  color: #fff;
}

.settings-plan-section__note {
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-side-hover, #4c5ed9);
  white-space: nowrap;
}

.settings-plan-section__caution {
  font-family: var(--font-sans);
  font-size: 13px;
  line-height: 1.6;
  color: var(--text-tertiary);
  margin: 0;
}

.settings-plan-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  align-items: stretch;
  width: 100%;
}

.settings-plan-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background: var(--fg-bg-card, #fbfbfb);
  border-radius: var(--radius-2xl, 12px);
  min-width: 0;
}

.settings-plan-card--accent {
  background: var(--fg-bg-liteblue, #f6f8ff);
}

.settings-plan-card__head {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 0;
}

.settings-plan-card__audience {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 400;
  color: #000;
}

.settings-plan-card__audience > svg {
  flex-shrink: 0;
}

.settings-plan-card__name {
  margin: 0;
  font-family: var(--font-sans);
  font-size: 24px;
  font-weight: 600;
  line-height: 1;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-plan-card__price {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-plan-card__currency {
  font-family: var(--font-sans);
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
}

.settings-plan-card__amount {
  flex: 1 1;
  font-family: var(--font-sans);
  font-size: 36px;
  font-weight: 600;
  line-height: 46px;
  min-width: 0;
  word-break: break-all;
}

.settings-plan-card__price-suffix {
  margin: 0;
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-plan-card__cta {
  min-height: 44px;
  padding: 12px;
  width: 100%;
  border: 0;
  border-radius: var(--radius-lg, 8px);
  background: var(--fg-button, #978cca);
  color: #fff;
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: background var(--transition-fast);
}

.settings-plan-card__cta:hover {
  background: var(--fg-button-hover, #7362c2);
}

.settings-plan-card__desc {
  margin: 0;
  font-family: var(--font-sans);
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-plan-card__features {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.settings-plan-card__feature {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-plan-card__feature--highlight {
  font-weight: 500;
  color: var(--fg-anti-red, #ff1500);
}

.settings-plan-card__feature-icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--fg-class-green, #629351);
}

.settings-plan-card__feature--highlight .settings-plan-card__feature-icon {
  color: var(--fg-anti-red, #ff1500);
}

.settings-plan-card__feature-text {
  flex: 1 1;
  min-width: 0;
  padding-top: 5px;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

/* 사용 내역 테이블 (Figma Frame 397) */
.settings-table {
  width: 100%;
  border-collapse: collapse;
  background: transparent;
  border: 0;
  border-radius: 0;
  overflow: visible;
  table-layout: fixed;
}

.settings-table thead th {
  height: 41px;
  padding: 12px;
  background: transparent;
  border-bottom: 1px solid var(--fg-text-basic, #3b3b3b);
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-gray, #838383);
  text-align: center;
  vertical-align: middle;
}

/* 잔액(가장 진한 #3b3b3b)이 본문 td 기본값 */
.settings-table tbody td {
  padding: 12px;
  border-bottom: 1px solid var(--fg-line, #dbdbdb);
  border-top: 0;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-basic, #3b3b3b);
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.settings-table tbody tr:first-child td {
  border-top: 0;
}

/* 일시·상세 — 회색 톤 */
.settings-table tbody td.settings-table__cell--muted {
  color: var(--fg-text-gray, #838383);
}

/* 유형 — Bold 초록 */
.settings-table tbody td.settings-table__type {
  font-weight: 700;
  color: var(--fg-class-green, #629351);
}

/* 사용액 — 빨강 */
.settings-table tbody td.settings-table__num--neg {
  color: var(--fg-anti-red, #ff1500);
  font-variant-numeric: tabular-nums;
}

/* 페이징 (Figma Frame 177 paging group) */
.settings-paging {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 20px;
}

.settings-paging__btn {
  min-width: 32px;
  height: 32px;
  padding: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--fg-bg-card, #fbfbfb);
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 0;
  font-family: inherit;
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  color: var(--fg-text-gray, #838383);
  cursor: pointer;
  transition: var(--transition-fast, all 0.15s ease);
}

.settings-paging__btn:hover:not(:disabled):not(.settings-paging__btn--active) {
  background: #fff;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-paging__btn--active {
  background: var(--fg-button, #978cca);
  border-color: var(--fg-button, #978cca);
  color: #fff;
}

.settings-paging__btn--icon {
  color: var(--fg-text-gray, #838383);
}

.settings-paging__btn--icon > svg {
  width: 18px;
  height: 18px;
}

.settings-paging__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.settings-paging__ellipsis {
  display: grid;
  place-items: center;
  width: 14px;
  height: 14px;
  margin: 0 2px;
  color: var(--fg-text-gray, #838383);
}

/* ───────── 알림/토글 행 ───────── */
.settings-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
  background: #fff;
}

.settings-toggle-row--disabled {
  opacity: 0.55;
  pointer-events: none;
}

.settings-toggle-row__body {
  flex: 1 1;
  min-width: 0;
}

.settings-toggle-row__label {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 500;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-toggle-row__helper {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: var(--fg-text-gray, #838383);
}

/* ───────── 보안: 디바이스 리스트 ───────── */
.settings-device-list {
  list-style: none;
  margin: 0;
  padding: 0;
  background: #fff;
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 12px;
  overflow: hidden;
}

.settings-device {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
}

.settings-device + .settings-device {
  border-top: 1px solid var(--fg-line, #dbdbdb);
}

.settings-device__icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  background: var(--fg-bg-liteblue, #f6f8ff);
  border-radius: 8px;
  color: var(--fg-button-hover, #7362c2);
}

.settings-device__body {
  flex: 1 1;
  min-width: 0;
}

.settings-device__name {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 600;
  color: var(--fg-text-basic, #3b3b3b);
  display: flex;
  align-items: center;
  gap: 8px;
}

.settings-device__badge {
  display: inline-flex;
  padding: 2px 8px;
  background: var(--fg-bg-liteblue, #f6f8ff);
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  color: var(--fg-button-hover, #7362c2);
}

.settings-device__meta {
  margin: 0;
  font-size: 13px;
  color: var(--fg-text-gray, #838383);
}

.settings-device__btn {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-gray, #838383);
  cursor: pointer;
}

.settings-device__btn:hover {
  background: rgba(0, 0, 0, 0.04);
  color: var(--danger-500, #ef4444);
}

/* ───────── 외부 연결 (Figma Frame 210) ───────── */
.settings-connection-group + .settings-connection-group {
  margin-top: 20px;
}

.settings-connection-group__title {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic, #3b3b3b);
}

/* 그룹 컨테이너: 배경을 회색 라인으로, 카드 사이 1px gap으로 구분선 효과 */
.settings-connection-group__list {
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: var(--fg-line, #dbdbdb);
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 12px;
  overflow: hidden;
}

.settings-connection {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: #fff;
}

.settings-connection__logo {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  object-fit: contain;
  margin-top: 2px;
}

.settings-connection__body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.settings-connection__name {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-connection__desc {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  color: var(--fg-text-basic, #3b3b3b);
  word-break: keep-all;
}

.settings-connection__date {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  color: var(--fg-text-gray, #838383);
}

.settings-connection__action {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* 연결됨 — 32x32 라임그린 라운드 플러그 버튼 */
.settings-connection__plug {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  padding: 4px;
  background: var(--fg-bg-connect-on, #aaf054);
  border: 0;
  border-radius: 16px;
  color: var(--fg-text-basic, #3b3b3b);
  cursor: pointer;
  transition: var(--transition-fast, all 0.15s ease);
}

.settings-connection__plug:hover {
  background: #95dd45;
}

/* 미연결 — 보라 텍스트의 toolbar 버튼 (서비스 연결 / 토큰 직접 입력) */
.settings-connection__btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 5px 7px 7px;
  background: var(--fg-bg-litepp, #e8eaf5);
  border: 0;
  border-radius: 4px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-button-hover, #7362c2);
  cursor: pointer;
  white-space: nowrap;
  transition: var(--transition-fast, all 0.15s ease);
}

.settings-connection__btn:hover {
  background: #d8dbed;
}

.settings-connection__btn > svg {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}

/* 보안 안내 박스 (Figma: bg=#fff5f4) */
.settings-info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 24px;
  padding: 16px;
  background: #fff5f4;
  border-radius: 12px;
}

.settings-info__icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  color: var(--fg-anti-red, #ff1500);
}

.settings-info__body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.settings-info__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-info__text {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--fg-text-basic, #3b3b3b);
}

/* ===================================================
   고객 지원 (피그마 node-id 2056-13778)
   =================================================== */

/* ── 도움말 카드 그룹 (매뉴얼 + 문의) ── */
.settings-support-cards {
  display: flex;
  flex-direction: column;
  background: var(--fg-line, #dbdbdb);
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 12px;
  overflow: hidden;
  gap: 1px; /* 두 행 사이 1px 구분선 */
  margin-top: 24px;
}

.settings-support-cards__row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #fff;
}

.settings-support-cards__logo,
.settings-support-cards__icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-support-cards__logo {
  object-fit: contain;
}

.settings-support-cards__body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.settings-support-cards__title {
  margin: 0;
  font-family: 'Pretendard', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-support-cards__desc {
  margin: 0;
  font-family: 'Pretendard', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-support-cards__btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 5px 7px 7px;
  background: var(--fg-bg-litepp, #e8eaf5);
  border: 0;
  border-radius: 4px;
  font-family: 'Pretendard', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-button-hover, #7362c2);
  text-decoration: none;
  cursor: pointer;
  transition: var(--transition-fast, all 0.15s ease);
}

.settings-support-cards__btn:hover {
  background: #d7daea;
}

.settings-support-cards__btn svg {
  flex-shrink: 0;
}

/* ── 자주 묻는 질문 (아코디언) ── */
.settings-support-faq {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 32px;
}

.settings-support-faq__title {
  margin: 0;
  font-family: 'Pretendard', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-support-faq__list {
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: var(--fg-line, #dbdbdb);
  border: 1px solid var(--fg-line, #dbdbdb);
  border-radius: 12px;
  overflow: hidden;
}

.settings-support-faq__item {
  background: #fff;
  transition: background-color 0.15s ease;
}

.settings-support-faq__item:hover {
  background: var(--fg-bg-mychat, #fbfbfb);
}

.settings-support-faq__item--open,
.settings-support-faq__item--open:hover {
  background: #f3fbff;
}

.settings-support-faq__head {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 52px;
  padding: 16px;
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}

.settings-support-faq__q {
  flex: 1 1;
  min-width: 0;
  font-family: 'Pretendard', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-support-faq__chevron {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 20px;
  height: 20px;
  color: var(--fg-text-basic, #3b3b3b);
  transition: transform 0.2s ease;
}

.settings-support-faq__chevron--up {
  transform: rotate(180deg);
}

.settings-support-faq__body {
  padding: 0 16px 20px;
}

.settings-support-faq__a {
  margin: 0;
  font-family: 'Pretendard', sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.6;
  color: var(--fg-text-gray, #838383);
  white-space: pre-wrap;
}

/* ── 푸터 (GrowFit + BCT 로고 + copyright) ── */
.settings-support-footer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 40px;
  padding-top: 0;
}

.settings-support-footer__brand {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 12px;
}

.settings-support-footer__logo {
  height: 36px;
  width: auto;
  object-fit: contain;
}

.settings-support-footer__bct {
  height: 24px;
  width: auto;
  object-fit: contain;
}

.settings-support-footer__line {
  margin: 0;
  font-family: 'Pretendard', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic, #3b3b3b);
}

.settings-support-footer__line strong {
  font-weight: 700;
}

.settings-support-footer__copy {
  margin: 0;
  font-family: 'Pretendard', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-basic, #3b3b3b);
}

/* ───────── 계정 — 역할 행 (배지 + 파트너 신청) ───────── */
.settings-account__role-row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.settings-account__partner-apply {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: var(--fg-button-normal, #978cca);
  color: #fff;
  border: 0;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 120ms ease;
}

.settings-account__partner-apply:hover {
  background: var(--fg-button-hover, #7362c2);
}

.settings-account__partner-apply:focus-visible {
  outline: 2px solid var(--fg-button-hover, #7362c2);
  outline-offset: 2px;
}

.settings-account__partner-pending {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  background: var(--fg-bg-liteblue, #f6f8ff);
  border: 1px dashed var(--fg-button-normal, #978cca);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--fg-button-normal, #978cca);
}

.settings-account__error {
  margin: 0;
  font-size: 13px;
  color: var(--fg-anti-red, #ff1500);
}

/* ───────── 파트너 신청 모달 ───────── */
.partner-apply-modal {
  max-width: 560px;
}

.partner-apply-modal__head {
  position: relative;
  align-items: center;
  padding-top: 28px;
}

.partner-apply-modal__head-text {
  flex: 1 1;
  text-align: center;
}

.partner-apply-modal__back {
  position: absolute;
  top: 16px;
  left: 16px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 8px;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-gray, #6b7280);
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

.partner-apply-modal__back:hover {
  background: var(--fg-bg-liteblue, #f6f8ff);
  color: var(--fg-text-basic, #3b3b3b);
}

.partner-apply-modal__back:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.partner-apply-modal__steps {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px 4px;
}

.partner-apply-modal__step-dot {
  width: 28px;
  height: 4px;
  background: var(--fg-line, #e5e7eb);
  border-radius: 2px;
  transition: background 120ms ease;
}

.partner-apply-modal__step-dot.is-active {
  background: var(--fg-button-normal, #978cca);
}

.partner-apply-modal__body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.partner-apply-modal__benefits {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.partner-apply-modal__benefit {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px;
  background: var(--fg-bg-liteblue, #f6f8ff);
  border: 1px solid var(--fg-line, #e5e7eb);
  border-radius: 10px;
}

.partner-apply-modal__benefit strong {
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic, #3b3b3b);
}

.partner-apply-modal__benefit span {
  font-size: 12px;
  color: var(--fg-text-gray, #6b7280);
}

.partner-apply-modal__notice {
  padding: 12px 14px;
  background: #fff8e6;
  border: 1px solid #fde68a;
  border-radius: 10px;
}

.partner-apply-modal__notice strong {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #92400e;
  margin-bottom: 2px;
}

.partner-apply-modal__notice p {
  margin: 0;
  font-size: 12px;
  color: #92400e;
}

.partner-apply-modal__select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
}

.partner-apply-modal__divider {
  margin: 8px 0 0;
  padding-top: 12px;
  border-top: 1px solid var(--fg-line, #e5e7eb);
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-text-basic, #3b3b3b);
}

.partner-apply-modal__check {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  color: var(--fg-text-basic, #3b3b3b);
  cursor: pointer;
}

.partner-apply-modal__check input[type='checkbox'] {
  margin-top: 2px;
  width: 16px;
  height: 16px;
  accent-color: var(--fg-button-normal, #978cca);
  cursor: pointer;
}

.partner-apply-modal__required {
  font-style: normal;
  font-weight: 600;
  color: var(--fg-anti-red, #ff1500);
}

.partner-apply-modal__error {
  margin: 6px 0 0;
  font-size: 12px;
  color: var(--fg-anti-red, #ff1500);
}

.partner-apply-modal__error--inline {
  margin-top: -6px;
  margin-left: 24px;
}

/* 사용/결제 내역 테이블 가로 스크롤 래퍼 (데스크톱은 일반 블록, 모바일에서 스크롤) */
.settings-table-scroll {
  width: 100%;
}

/* ========================================================================
   모바일 (≤720px) — 설정 (계정 / 사용량 / 결제 / 외부연결 / 고객지원).
   사이드바는 프로젝트·AI채팅 패턴: 기본 접힘(레일), 펼치면 오버레이 드로어.
   공유 셸(.prompt__*)을 쓰므로 .settings-page 로 스코프해 타 기능 영향 차단.
   ======================================================================== */
@media (max-width: 720px) {
  /* 카드 셸 여백 제거 — 본문 폭 확보 */
  .settings-page .prompt__layout {
    margin: 0;
    border-radius: 0;
  }

  /* 펼친 사이드바 = 화면 위로 덮는 오버레이 드로어 (+ 큰 spread 그림자로 스크림) */
  .settings-page .prompt__sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 84vw;
    max-width: 320px;
    z-index: 200;
    box-shadow: 0 0 0 100vw rgba(14, 27, 43, 0.4), 8px 0 24px rgba(0, 0, 0, 0.18);
  }

  /* 접힘 = 레일을 띄우지 않고 좌상단 플로팅 토글 버튼만 노출 → 본문 풀폭 */
  .settings-page .prompt__sidebar--collapsed {
    position: fixed;
    top: 60px;
    left: 12px;
    bottom: auto;
    width: auto;
    padding: 0;
    gap: 0;
    background: transparent;
    box-shadow: none;
    z-index: 60;
  }

  .settings-page .prompt__sidebar--collapsed .prompt__sidebar-collapsed-nav {
    display: none;
  }

  /* 토글 = AI채팅/프로젝트 플로팅 메뉴 스타일(흰 버튼 + 그림자) */
  .settings-page .prompt__sidebar--collapsed .prompt__sidebar-mini-btn--toggle {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: #fff;
    border: 1px solid var(--fg-line);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    color: var(--fg-text-basic);
  }

  /* 본문 — 풀폭 + 플로팅 토글과 안 겹치게 제목 줄 들여쓰기 */
  .settings-page .settings__content {
    padding: 20px 16px 64px;
  }

  .settings-page .settings__heading {
    min-height: 40px;
    padding-left: 48px;
  }

  .settings-page .settings__title {
    font-size: 22px;
  }

  /* 폼 행 — 세로 스택 (라벨 180px 고정폭 해제) */
  .settings-page .settings-form {
    flex-direction: column;
    gap: 8px;
  }

  .settings-page .settings-form__label-wrap {
    width: auto;
    padding-top: 0;
  }

  .settings-page .settings-form__control-wrap {
    max-width: none;
  }

  /* 계정 헤더 — 아바타/이름 축소 */
  .settings-page .settings-account__avatar-wrap,
  .settings-page .settings-account__avatar {
    width: 120px;
    height: 120px;
  }

  .settings-page .settings-account__name {
    font-size: 28px;
    line-height: 38px;
  }

  /* 요금제/플랜 섹션 타이틀 축소 */
  .settings-page .settings-plan-section__title {
    font-size: 22px;
    line-height: 32px;
  }

  /* 토큰 hero — 진행바와 충전 버튼을 세로로 스택 */
  .settings-page .settings-token-hero {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .settings-page .settings-token-hero__btn {
    justify-content: center;
  }

  /* 사용/결제 내역 테이블 — 가로 스크롤로 컬럼 찌부 방지 */
  .settings-page .settings-table-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .settings-page .settings-table {
    min-width: 480px;
  }

  /* 파트너 신청 모달 — 혜택 2열 → 1열 */
  .settings-page .partner-apply-modal__benefits {
    grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/css/Settings.css"],"names":[],"mappings":"AAAA;;;6EAG6E;;AAE7E,4DAA4D;AAC5D,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,mCAAmC;EACnC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;;;qEAGqE;AACrE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,mCAAmC;EACnC,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,wCAAwC;EACxC,sCAAsC;EACtC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,sCAAsC;EACtC,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,SAAS;EACT,oCAAoC;EACpC,qCAAqC;EACrC,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,sDAAsD;EACtD,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,aAAa;AACb;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,yCAAyC;EACzC,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mCAAmC;AACrC;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,0CAA0C;EAC1C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;EAC5C,SAAS;EACT,mBAAmB;EACnB,oCAAoC;EACpC,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iDAAiD;AACjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,wCAAwC;EACxC,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;;wDAEwD;;AAExD,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ,EAAE,mBAAmB;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,wCAAwC;EACxC,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,qBAAqB;EACrB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA,gDAAgD;AAChD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4CAA4C;EAC5C,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;EAC1C,mDAAmD;EACnD,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,0CAA0C;EAC1C,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yDAAiS;EACjS,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,WAAW;AACb;;AAEA;;;;6EAI6E;AAC7E;EACE,yBAAyB;EACzB;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA,sDAAsD;EACtD;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,6EAA6E;EAC/E;;EAEA,8CAA8C;EAC9C;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,UAAU;IACV,MAAM;IACN,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA,0CAA0C;EAC1C;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;IAChC,yCAAyC;IACzC,2BAA2B;EAC7B;;EAEA,sCAAsC;EACtC;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA,sBAAsB;EACtB;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,qBAAqB;EACrB;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,iCAAiC;EACjC;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA,oCAAoC;EACpC;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA,2BAA2B;EAC3B;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ========================================================================\n   Settings — 설정 영역\n   사이드바 + 우측 컨텐츠 (760px 고정폭) 레이아웃\n   ======================================================================== */\n\n/* ───────── 사이드바 (Figma Frame 81 — 라이트 #f2f2f2) ───────── */\n/* 컨테이너 배경/너비/패딩은 .prompt__sidebar 기본을 그대로 사용 */\n.settings__sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.settings__sidebar-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 0;\n}\n\n/* 메뉴 항목 — 폭 100% / padding 10px / gap 4px / radius 12px */\n.settings__sidebar-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 10px;\n  background: transparent;\n  border: 0;\n  border-radius: 12px;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 1;\n  color: var(--fg-text-basic, #3b3b3b);\n  cursor: pointer;\n  text-align: left;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.settings__sidebar-item:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.settings__sidebar-item--active {\n  background: #fff;\n  color: var(--fg-text-basic, #3b3b3b);\n  font-weight: 500;\n  box-shadow: none;\n}\n\n.settings__sidebar-item--active:hover {\n  background: #fff;\n}\n\n.settings__sidebar-item--logout {\n  margin-top: 8px;\n}\n\n.settings__sidebar-item--logout:hover {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--danger-500, #ef4444);\n}\n\n.settings__sidebar-item-icon {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  color: inherit;\n}\n\n.settings__sidebar-item-label {\n  flex: 1;\n}\n\n/* ───────── 컨텐츠 영역 ───────── */\n.settings__main {\n  display: flex;\n  justify-content: center;\n}\n\n.settings__content {\n  width: 100%;\n  padding: 30px 0 80px;\n  margin: 0 auto;\n}\n\n.settings__heading {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 24px;\n}\n\n.settings__title {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 600;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings__heading-help {\n  width: 24px;\n  height: 24px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  color: var(--fg-text-gray, #838383);\n  cursor: pointer;\n}\n\n.settings__description {\n  margin: -12px 0 24px;\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--fg-text-gray, #838383);\n}\n\n/* ───────── 섹션 ───────── */\n.settings-section {\n  margin-bottom: 32px;\n}\n\n.settings-section__title {\n  margin: 0 0 12px;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-section__sub {\n  margin: -8px 0 16px;\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--fg-text-gray, #838383);\n}\n\n.settings-section__group {\n  background: #fff;\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.settings-section__group > * + * {\n  border-top: 1px solid var(--fg-line, #dbdbdb);\n}\n\n/* ───────── 폼 행 ───────── */\n.settings-form {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px;\n  background: #fff;\n}\n\n.settings-form--readonly {\n  background: var(--fg-box-bg, #fbfbfb);\n}\n\n.settings-form__label-wrap {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  padding-top: 12px;\n  flex-shrink: 0;\n  width: 180px;\n}\n\n.settings-form__label {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-form__required {\n  display: inline-flex;\n  align-items: center;\n  margin-top: 4px;\n  color: #e74c3c;\n}\n\n.settings-form__control-wrap {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-width: 540px;\n}\n\n.settings-form__input {\n  width: 100%;\n  padding: 8px 12px;\n  background: #f8f8f8;\n  border: 0;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic, #3b3b3b);\n  outline: none;\n}\n\n.settings-form__input::placeholder {\n  color: var(--fg-text-gray, #838383);\n}\n\n.settings-form__input:focus {\n  background: #fff;\n  box-shadow: inset 0 0 0 1px var(--fg-button-hover, #7362c2);\n}\n\n.settings-form__input--readonly {\n  background: var(--fg-box-bg, #fbfbfb);\n  border: 1px solid var(--fg-line, #dbdbdb);\n  color: var(--fg-text-gray, #838383);\n  display: flex;\n  align-items: center;\n}\n\n.settings-form__input--select {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  text-align: left;\n}\n\n.settings-form__placeholder {\n  color: var(--fg-text-gray, #838383);\n}\n\n.settings-form__textarea {\n  width: 100%;\n  min-height: 113px;\n  padding: 8px 12px;\n  background: #f8f8f8;\n  border: 0;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic, #3b3b3b);\n  outline: none;\n  resize: vertical;\n}\n\n.settings-form__textarea::placeholder {\n  color: var(--fg-text-gray, #838383);\n}\n\n.settings-form__helper {\n  margin: 0;\n  font-size: 14px;\n  color: var(--fg-text-gray, #838383);\n}\n\n/* ───────── 액션 버튼 ───────── */\n.settings-action-row {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 24px;\n}\n\n.settings-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 48px;\n  padding: 10px 16px;\n  border: 0;\n  border-radius: 12px;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.settings-btn--primary {\n  background: var(--fg-button-normal, #978cca);\n  color: #fff;\n}\n\n.settings-btn--primary:hover {\n  background: var(--fg-button-hover, #7362c2);\n}\n\n.settings-btn--secondary {\n  background: var(--fg-text-gray, #838383);\n  color: #fff;\n}\n\n.settings-btn--secondary:hover {\n  background: #555;\n}\n\n.settings-btn--ghost {\n  background: #fff;\n  border: 1px solid var(--fg-line, #dbdbdb);\n  color: var(--fg-text-basic, #3b3b3b);\n  min-height: 36px;\n  padding: 6px 10px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.settings-btn--ghost:hover {\n  background: var(--fg-bg-liteblue, #f6f8ff);\n}\n\n.settings-btn--has-text {\n  padding: 6px 12px;\n}\n\n.settings-btn--sm {\n  min-height: 32px;\n  padding: 4px 12px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* ───────── 계정 화면 ───────── */\n.settings-account {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.settings-account__profile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.settings-account__avatar-wrap {\n  position: relative;\n  width: 160px;\n  height: 160px;\n}\n\n.settings-account__avatar {\n  width: 160px;\n  height: 160px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #d8d4ee, #978cca);\n}\n\n.settings-account__avatar-btn {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: #fff;\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 50%;\n  color: var(--fg-text-basic, #3b3b3b);\n  cursor: pointer;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n}\n\n.settings-account__name {\n  margin: 0;\n  font-size: 36px;\n  font-weight: 600;\n  line-height: 46px;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-account__email {\n  margin: 0;\n  font-size: 14px;\n  color: var(--link-normal, #2c95f8);\n}\n\n.settings-account__badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-text-basic, #3b3b3b);\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-account__form-group {\n  background: #fff;\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.settings-account__form-group > .settings-form + .settings-form {\n  border-top: 1px solid var(--fg-line, #dbdbdb);\n}\n\n/* ───────── 토큰 화면 (Figma Frame 395) ───────── */\n.settings-token-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 32px;\n}\n\n/* Frame 228 — 다크 hero (잔여 토큰 진행바 + 충전/요금제 버튼) */\n.settings-token-hero {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 20px;\n  background: var(--fg-bg-dark, #2f3247);\n  border-radius: 12px;\n}\n\n.settings-token-hero__bar-wrap {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.settings-token-hero__bar-head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.settings-token-hero__bar-label {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--fg-text-menu, #bdbdbd);\n}\n\n.settings-token-hero__bar-value {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-anti-red, #ff1500);\n  white-space: nowrap;\n  text-align: right;\n}\n\n/* 진행바 — fill을 우측 정렬 */\n.settings-token-hero__bar {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  height: 5px;\n  background: var(--fg-text-menu, #bdbdbd);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.settings-token-hero__bar-fill {\n  height: 100%;\n  background: var(--fg-anti-red, #ff1500);\n  border-radius: 10px;\n}\n\n/* 우측 toolbar 버튼 (충전 / 요금제 업그레이드) */\n.settings-token-hero__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 32px;\n  padding: 5px 7px 7px;\n  background: var(--fg-button, #978cca);\n  border: 0;\n  border-radius: 4px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.settings-token-hero__btn:hover {\n  background: var(--fg-button-hover, #7362c2);\n}\n\n.settings-token-hero__btn > svg {\n  flex-shrink: 0;\n}\n\n/* 3개 카드 — 각자 분리된 박스 (gap 8px) */\n.settings-token-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.settings-token-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 12px;\n}\n\n/* 잔여 토큰(첫 번째) 강조 카드 — 옅은 푸른 배경 + 보라 네이비 보더 */\n.settings-token-card--highlight {\n  background: #f3fbff;\n  border-color: var(--fg-side-hover, #4c5ed9);\n}\n\n.settings-token-card__body {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.settings-token-card__label {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-token-card__sub {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--fg-text-gray, #838383);\n}\n\n.settings-token-card__value {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--fg-side-hover, #4c5ed9);\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ================================================================\n * 요금제 섹션 (피그마 node 1:7001)\n *   - 헤더 + 결제 주기 토글 + 3-컬럼 플랜 카드 그리드\n * ================================================================ */\n.settings-plan-section {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-bottom: 40px;\n}\n\n.settings-plan-section__head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 40px;\n}\n\n.settings-plan-section__title {\n  margin: 0;\n  font-family: var(--font-sans);\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 40px;\n  color: var(--fg-text-basic, #3b3b3b);\n  letter-spacing: 0;\n}\n\n.settings-plan-section__help {\n  border: 0;\n  background: transparent;\n  width: 32px;\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-md, 6px);\n  color: var(--fg-text-gray, #838383);\n  cursor: pointer;\n  padding: 0;\n}\n\n.settings-plan-section__help:hover {\n  color: var(--fg-text-basic, #3b3b3b);\n  background: var(--fg-bg-content, var(--gray-100));\n}\n\n.settings-plan-section__controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.settings-plan-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 1px;\n  border-radius: var(--radius-sm, 4px);\n  overflow: hidden;\n}\n\n.settings-plan-toggle__btn {\n  height: 32px;\n  padding: 5px 7px 7px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  background: var(--fg-bg-litepp, #e8eaf5);\n  color: var(--fg-button-hover, #7362c2);\n  font-family: var(--font-sans);\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  cursor: pointer;\n  transition: background var(--transition-fast), color var(--transition-fast);\n}\n\n.settings-plan-toggle__btn:hover {\n  background: #dfe2f0;\n}\n\n.settings-plan-toggle__btn--active,\n.settings-plan-toggle__btn--active:hover {\n  background: var(--fg-button, #978cca);\n  color: #fff;\n}\n\n.settings-plan-section__note {\n  font-family: var(--font-sans);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-side-hover, #4c5ed9);\n  white-space: nowrap;\n}\n\n.settings-plan-section__caution {\n  font-family: var(--font-sans);\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--text-tertiary);\n  margin: 0;\n}\n\n.settings-plan-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 20px;\n  align-items: stretch;\n  width: 100%;\n}\n\n.settings-plan-card {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 20px;\n  background: var(--fg-bg-card, #fbfbfb);\n  border-radius: var(--radius-2xl, 12px);\n  min-width: 0;\n}\n\n.settings-plan-card--accent {\n  background: var(--fg-bg-liteblue, #f6f8ff);\n}\n\n.settings-plan-card__head {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0;\n  padding: 0;\n}\n\n.settings-plan-card__audience {\n  display: flex;\n  align-items: flex-end;\n  gap: 4px;\n  font-family: var(--font-sans);\n  font-size: 14px;\n  font-weight: 400;\n  color: #000;\n}\n\n.settings-plan-card__audience > svg {\n  flex-shrink: 0;\n}\n\n.settings-plan-card__name {\n  margin: 0;\n  font-family: var(--font-sans);\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 1;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-plan-card__price {\n  display: flex;\n  align-items: flex-end;\n  gap: 4px;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-plan-card__currency {\n  font-family: var(--font-sans);\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 28px;\n}\n\n.settings-plan-card__amount {\n  flex: 1;\n  font-family: var(--font-sans);\n  font-size: 36px;\n  font-weight: 600;\n  line-height: 46px;\n  min-width: 0;\n  word-break: break-all;\n}\n\n.settings-plan-card__price-suffix {\n  margin: 0;\n  font-family: var(--font-sans);\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-plan-card__cta {\n  min-height: 44px;\n  padding: 12px;\n  width: 100%;\n  border: 0;\n  border-radius: var(--radius-lg, 8px);\n  background: var(--fg-button, #978cca);\n  color: #fff;\n  font-family: var(--font-sans);\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n  transition: background var(--transition-fast);\n}\n\n.settings-plan-card__cta:hover {\n  background: var(--fg-button-hover, #7362c2);\n}\n\n.settings-plan-card__desc {\n  margin: 0;\n  font-family: var(--font-sans);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-plan-card__features {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.settings-plan-card__feature {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  font-family: var(--font-sans);\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-plan-card__feature--highlight {\n  font-weight: 500;\n  color: var(--fg-anti-red, #ff1500);\n}\n\n.settings-plan-card__feature-icon {\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--fg-class-green, #629351);\n}\n\n.settings-plan-card__feature--highlight .settings-plan-card__feature-icon {\n  color: var(--fg-anti-red, #ff1500);\n}\n\n.settings-plan-card__feature-text {\n  flex: 1;\n  min-width: 0;\n  padding-top: 5px;\n  word-break: keep-all;\n  overflow-wrap: anywhere;\n}\n\n/* 사용 내역 테이블 (Figma Frame 397) */\n.settings-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: transparent;\n  border: 0;\n  border-radius: 0;\n  overflow: visible;\n  table-layout: fixed;\n}\n\n.settings-table thead th {\n  height: 41px;\n  padding: 12px;\n  background: transparent;\n  border-bottom: 1px solid var(--fg-text-basic, #3b3b3b);\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-gray, #838383);\n  text-align: center;\n  vertical-align: middle;\n}\n\n/* 잔액(가장 진한 #3b3b3b)이 본문 td 기본값 */\n.settings-table tbody td {\n  padding: 12px;\n  border-bottom: 1px solid var(--fg-line, #dbdbdb);\n  border-top: 0;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-basic, #3b3b3b);\n  text-align: center;\n  vertical-align: middle;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.settings-table tbody tr:first-child td {\n  border-top: 0;\n}\n\n/* 일시·상세 — 회색 톤 */\n.settings-table tbody td.settings-table__cell--muted {\n  color: var(--fg-text-gray, #838383);\n}\n\n/* 유형 — Bold 초록 */\n.settings-table tbody td.settings-table__type {\n  font-weight: 700;\n  color: var(--fg-class-green, #629351);\n}\n\n/* 사용액 — 빨강 */\n.settings-table tbody td.settings-table__num--neg {\n  color: var(--fg-anti-red, #ff1500);\n  font-variant-numeric: tabular-nums;\n}\n\n/* 페이징 (Figma Frame 177 paging group) */\n.settings-paging {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  margin-top: 20px;\n}\n\n.settings-paging__btn {\n  min-width: 32px;\n  height: 32px;\n  padding: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--fg-bg-card, #fbfbfb);\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 0;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--fg-text-gray, #838383);\n  cursor: pointer;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.settings-paging__btn:hover:not(:disabled):not(.settings-paging__btn--active) {\n  background: #fff;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-paging__btn--active {\n  background: var(--fg-button, #978cca);\n  border-color: var(--fg-button, #978cca);\n  color: #fff;\n}\n\n.settings-paging__btn--icon {\n  color: var(--fg-text-gray, #838383);\n}\n\n.settings-paging__btn--icon > svg {\n  width: 18px;\n  height: 18px;\n}\n\n.settings-paging__btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.settings-paging__ellipsis {\n  display: grid;\n  place-items: center;\n  width: 14px;\n  height: 14px;\n  margin: 0 2px;\n  color: var(--fg-text-gray, #838383);\n}\n\n/* ───────── 알림/토글 행 ───────── */\n.settings-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px 20px;\n  background: #fff;\n}\n\n.settings-toggle-row--disabled {\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n.settings-toggle-row__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.settings-toggle-row__label {\n  margin: 0 0 4px;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-toggle-row__helper {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--fg-text-gray, #838383);\n}\n\n/* ───────── 보안: 디바이스 리스트 ───────── */\n.settings-device-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.settings-device {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n}\n\n.settings-device + .settings-device {\n  border-top: 1px solid var(--fg-line, #dbdbdb);\n}\n\n.settings-device__icon {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  display: grid;\n  place-items: center;\n  background: var(--fg-bg-liteblue, #f6f8ff);\n  border-radius: 8px;\n  color: var(--fg-button-hover, #7362c2);\n}\n\n.settings-device__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.settings-device__name {\n  margin: 0 0 4px;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--fg-text-basic, #3b3b3b);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.settings-device__badge {\n  display: inline-flex;\n  padding: 2px 8px;\n  background: var(--fg-bg-liteblue, #f6f8ff);\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--fg-button-hover, #7362c2);\n}\n\n.settings-device__meta {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-text-gray, #838383);\n}\n\n.settings-device__btn {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-gray, #838383);\n  cursor: pointer;\n}\n\n.settings-device__btn:hover {\n  background: rgba(0, 0, 0, 0.04);\n  color: var(--danger-500, #ef4444);\n}\n\n/* ───────── 외부 연결 (Figma Frame 210) ───────── */\n.settings-connection-group + .settings-connection-group {\n  margin-top: 20px;\n}\n\n.settings-connection-group__title {\n  margin: 0 0 12px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n/* 그룹 컨테이너: 배경을 회색 라인으로, 카드 사이 1px gap으로 구분선 효과 */\n.settings-connection-group__list {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  background: var(--fg-line, #dbdbdb);\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.settings-connection {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  background: #fff;\n}\n\n.settings-connection__logo {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  object-fit: contain;\n  margin-top: 2px;\n}\n\n.settings-connection__body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.settings-connection__name {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-connection__desc {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.4;\n  color: var(--fg-text-basic, #3b3b3b);\n  word-break: keep-all;\n}\n\n.settings-connection__date {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.4;\n  color: var(--fg-text-gray, #838383);\n}\n\n.settings-connection__action {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* 연결됨 — 32x32 라임그린 라운드 플러그 버튼 */\n.settings-connection__plug {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  padding: 4px;\n  background: var(--fg-bg-connect-on, #aaf054);\n  border: 0;\n  border-radius: 16px;\n  color: var(--fg-text-basic, #3b3b3b);\n  cursor: pointer;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.settings-connection__plug:hover {\n  background: #95dd45;\n}\n\n/* 미연결 — 보라 텍스트의 toolbar 버튼 (서비스 연결 / 토큰 직접 입력) */\n.settings-connection__btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 32px;\n  padding: 5px 7px 7px;\n  background: var(--fg-bg-litepp, #e8eaf5);\n  border: 0;\n  border-radius: 4px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-button-hover, #7362c2);\n  cursor: pointer;\n  white-space: nowrap;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.settings-connection__btn:hover {\n  background: #d8dbed;\n}\n\n.settings-connection__btn > svg {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n}\n\n/* 보안 안내 박스 (Figma: bg=#fff5f4) */\n.settings-info {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-top: 24px;\n  padding: 16px;\n  background: #fff5f4;\n  border-radius: 12px;\n}\n\n.settings-info__icon {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  display: grid;\n  place-items: center;\n  color: var(--fg-anti-red, #ff1500);\n}\n\n.settings-info__body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.settings-info__title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-info__text {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n/* ===================================================\n   고객 지원 (피그마 node-id 2056-13778)\n   =================================================== */\n\n/* ── 도움말 카드 그룹 (매뉴얼 + 문의) ── */\n.settings-support-cards {\n  display: flex;\n  flex-direction: column;\n  background: var(--fg-line, #dbdbdb);\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 12px;\n  overflow: hidden;\n  gap: 1px; /* 두 행 사이 1px 구분선 */\n  margin-top: 24px;\n}\n\n.settings-support-cards__row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  background: #fff;\n}\n\n.settings-support-cards__logo,\n.settings-support-cards__icon {\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-support-cards__logo {\n  object-fit: contain;\n}\n\n.settings-support-cards__body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.settings-support-cards__title {\n  margin: 0;\n  font-family: 'Pretendard', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-support-cards__desc {\n  margin: 0;\n  font-family: 'Pretendard', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-support-cards__btn {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 32px;\n  padding: 5px 7px 7px;\n  background: var(--fg-bg-litepp, #e8eaf5);\n  border: 0;\n  border-radius: 4px;\n  font-family: 'Pretendard', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-button-hover, #7362c2);\n  text-decoration: none;\n  cursor: pointer;\n  transition: var(--transition-fast, all 0.15s ease);\n}\n\n.settings-support-cards__btn:hover {\n  background: #d7daea;\n}\n\n.settings-support-cards__btn svg {\n  flex-shrink: 0;\n}\n\n/* ── 자주 묻는 질문 (아코디언) ── */\n.settings-support-faq {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 32px;\n}\n\n.settings-support-faq__title {\n  margin: 0;\n  font-family: 'Pretendard', sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-support-faq__list {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  background: var(--fg-line, #dbdbdb);\n  border: 1px solid var(--fg-line, #dbdbdb);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.settings-support-faq__item {\n  background: #fff;\n  transition: background-color 0.15s ease;\n}\n\n.settings-support-faq__item:hover {\n  background: var(--fg-bg-mychat, #fbfbfb);\n}\n\n.settings-support-faq__item--open,\n.settings-support-faq__item--open:hover {\n  background: #f3fbff;\n}\n\n.settings-support-faq__head {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 52px;\n  padding: 16px;\n  background: transparent;\n  border: 0;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n}\n\n.settings-support-faq__q {\n  flex: 1;\n  min-width: 0;\n  font-family: 'Pretendard', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.4;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-support-faq__chevron {\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  width: 20px;\n  height: 20px;\n  color: var(--fg-text-basic, #3b3b3b);\n  transition: transform 0.2s ease;\n}\n\n.settings-support-faq__chevron--up {\n  transform: rotate(180deg);\n}\n\n.settings-support-faq__body {\n  padding: 0 16px 20px;\n}\n\n.settings-support-faq__a {\n  margin: 0;\n  font-family: 'Pretendard', sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1.6;\n  color: var(--fg-text-gray, #838383);\n  white-space: pre-wrap;\n}\n\n/* ── 푸터 (GrowFit + BCT 로고 + copyright) ── */\n.settings-support-footer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 40px;\n  padding-top: 0;\n}\n\n.settings-support-footer__brand {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 12px;\n}\n\n.settings-support-footer__logo {\n  height: 36px;\n  width: auto;\n  object-fit: contain;\n}\n\n.settings-support-footer__bct {\n  height: 24px;\n  width: auto;\n  object-fit: contain;\n}\n\n.settings-support-footer__line {\n  margin: 0;\n  font-family: 'Pretendard', sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.settings-support-footer__line strong {\n  font-weight: 700;\n}\n\n.settings-support-footer__copy {\n  margin: 0;\n  font-family: 'Pretendard', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n/* ───────── 계정 — 역할 행 (배지 + 파트너 신청) ───────── */\n.settings-account__role-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.settings-account__partner-apply {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  background: var(--fg-button-normal, #978cca);\n  color: #fff;\n  border: 0;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 120ms ease;\n}\n\n.settings-account__partner-apply:hover {\n  background: var(--fg-button-hover, #7362c2);\n}\n\n.settings-account__partner-apply:focus-visible {\n  outline: 2px solid var(--fg-button-hover, #7362c2);\n  outline-offset: 2px;\n}\n\n.settings-account__partner-pending {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 10px;\n  background: var(--fg-bg-liteblue, #f6f8ff);\n  border: 1px dashed var(--fg-button-normal, #978cca);\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--fg-button-normal, #978cca);\n}\n\n.settings-account__error {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-anti-red, #ff1500);\n}\n\n/* ───────── 파트너 신청 모달 ───────── */\n.partner-apply-modal {\n  max-width: 560px;\n}\n\n.partner-apply-modal__head {\n  position: relative;\n  align-items: center;\n  padding-top: 28px;\n}\n\n.partner-apply-modal__head-text {\n  flex: 1;\n  text-align: center;\n}\n\n.partner-apply-modal__back {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 8px;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-gray, #6b7280);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.partner-apply-modal__back:hover {\n  background: var(--fg-bg-liteblue, #f6f8ff);\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.partner-apply-modal__back:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.partner-apply-modal__steps {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 24px 4px;\n}\n\n.partner-apply-modal__step-dot {\n  width: 28px;\n  height: 4px;\n  background: var(--fg-line, #e5e7eb);\n  border-radius: 2px;\n  transition: background 120ms ease;\n}\n\n.partner-apply-modal__step-dot.is-active {\n  background: var(--fg-button-normal, #978cca);\n}\n\n.partner-apply-modal__body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.partner-apply-modal__benefits {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.partner-apply-modal__benefit {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 12px;\n  background: var(--fg-bg-liteblue, #f6f8ff);\n  border: 1px solid var(--fg-line, #e5e7eb);\n  border-radius: 10px;\n}\n\n.partner-apply-modal__benefit strong {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.partner-apply-modal__benefit span {\n  font-size: 12px;\n  color: var(--fg-text-gray, #6b7280);\n}\n\n.partner-apply-modal__notice {\n  padding: 12px 14px;\n  background: #fff8e6;\n  border: 1px solid #fde68a;\n  border-radius: 10px;\n}\n\n.partner-apply-modal__notice strong {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #92400e;\n  margin-bottom: 2px;\n}\n\n.partner-apply-modal__notice p {\n  margin: 0;\n  font-size: 12px;\n  color: #92400e;\n}\n\n.partner-apply-modal__select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  padding-right: 36px;\n}\n\n.partner-apply-modal__divider {\n  margin: 8px 0 0;\n  padding-top: 12px;\n  border-top: 1px solid var(--fg-line, #e5e7eb);\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--fg-text-basic, #3b3b3b);\n}\n\n.partner-apply-modal__check {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--fg-text-basic, #3b3b3b);\n  cursor: pointer;\n}\n\n.partner-apply-modal__check input[type='checkbox'] {\n  margin-top: 2px;\n  width: 16px;\n  height: 16px;\n  accent-color: var(--fg-button-normal, #978cca);\n  cursor: pointer;\n}\n\n.partner-apply-modal__required {\n  font-style: normal;\n  font-weight: 600;\n  color: var(--fg-anti-red, #ff1500);\n}\n\n.partner-apply-modal__error {\n  margin: 6px 0 0;\n  font-size: 12px;\n  color: var(--fg-anti-red, #ff1500);\n}\n\n.partner-apply-modal__error--inline {\n  margin-top: -6px;\n  margin-left: 24px;\n}\n\n/* 사용/결제 내역 테이블 가로 스크롤 래퍼 (데스크톱은 일반 블록, 모바일에서 스크롤) */\n.settings-table-scroll {\n  width: 100%;\n}\n\n/* ========================================================================\n   모바일 (≤720px) — 설정 (계정 / 사용량 / 결제 / 외부연결 / 고객지원).\n   사이드바는 프로젝트·AI채팅 패턴: 기본 접힘(레일), 펼치면 오버레이 드로어.\n   공유 셸(.prompt__*)을 쓰므로 .settings-page 로 스코프해 타 기능 영향 차단.\n   ======================================================================== */\n@media (max-width: 720px) {\n  /* 카드 셸 여백 제거 — 본문 폭 확보 */\n  .settings-page .prompt__layout {\n    margin: 0;\n    border-radius: 0;\n  }\n\n  /* 펼친 사이드바 = 화면 위로 덮는 오버레이 드로어 (+ 큰 spread 그림자로 스크림) */\n  .settings-page .prompt__sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 84vw;\n    max-width: 320px;\n    z-index: 200;\n    box-shadow: 0 0 0 100vw rgba(14, 27, 43, 0.4), 8px 0 24px rgba(0, 0, 0, 0.18);\n  }\n\n  /* 접힘 = 레일을 띄우지 않고 좌상단 플로팅 토글 버튼만 노출 → 본문 풀폭 */\n  .settings-page .prompt__sidebar--collapsed {\n    position: fixed;\n    top: 60px;\n    left: 12px;\n    bottom: auto;\n    width: auto;\n    padding: 0;\n    gap: 0;\n    background: transparent;\n    box-shadow: none;\n    z-index: 60;\n  }\n\n  .settings-page .prompt__sidebar--collapsed .prompt__sidebar-collapsed-nav {\n    display: none;\n  }\n\n  /* 토글 = AI채팅/프로젝트 플로팅 메뉴 스타일(흰 버튼 + 그림자) */\n  .settings-page .prompt__sidebar--collapsed .prompt__sidebar-mini-btn--toggle {\n    width: 40px;\n    height: 40px;\n    border-radius: 12px;\n    background: #fff;\n    border: 1px solid var(--fg-line);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n    color: var(--fg-text-basic);\n  }\n\n  /* 본문 — 풀폭 + 플로팅 토글과 안 겹치게 제목 줄 들여쓰기 */\n  .settings-page .settings__content {\n    padding: 20px 16px 64px;\n  }\n\n  .settings-page .settings__heading {\n    min-height: 40px;\n    padding-left: 48px;\n  }\n\n  .settings-page .settings__title {\n    font-size: 22px;\n  }\n\n  /* 폼 행 — 세로 스택 (라벨 180px 고정폭 해제) */\n  .settings-page .settings-form {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .settings-page .settings-form__label-wrap {\n    width: auto;\n    padding-top: 0;\n  }\n\n  .settings-page .settings-form__control-wrap {\n    max-width: none;\n  }\n\n  /* 계정 헤더 — 아바타/이름 축소 */\n  .settings-page .settings-account__avatar-wrap,\n  .settings-page .settings-account__avatar {\n    width: 120px;\n    height: 120px;\n  }\n\n  .settings-page .settings-account__name {\n    font-size: 28px;\n    line-height: 38px;\n  }\n\n  /* 요금제/플랜 섹션 타이틀 축소 */\n  .settings-page .settings-plan-section__title {\n    font-size: 22px;\n    line-height: 32px;\n  }\n\n  /* 토큰 hero — 진행바와 충전 버튼을 세로로 스택 */\n  .settings-page .settings-token-hero {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 12px;\n  }\n\n  .settings-page .settings-token-hero__btn {\n    justify-content: center;\n  }\n\n  /* 사용/결제 내역 테이블 — 가로 스크롤로 컬럼 찌부 방지 */\n  .settings-page .settings-table-scroll {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .settings-page .settings-table {\n    min-width: 480px;\n  }\n\n  /* 파트너 신청 모달 — 혜택 2열 → 1열 */\n  .settings-page .partner-apply-modal__benefits {\n    grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
